import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import { baseUrl, baseimgUrl, userLocation, ipAddress, userName } from '../Univ.js';

function LeaveApplication(props) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [empData, setEmpData] = useState([]);
  const [emp, setEmp] = useState('');
  const [type, setType] = useState('');
  const [reason, setReason] = useState('');
  const [viewLeave, setviewLeave] = useState([]);
const [lop, setLop] = useState("");

  // Calculate total days whenever dates change
  useEffect(() => {
    if (startDate && endDate) {
      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start & end
      setLop(diffDays);
    } else {
      setLop("");
    }
  }, [startDate, endDate]);

  const handleStartDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setStartDate(localDate);
  };

  const handleEndDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setEndDate(localDate);
  };

  useEffect(() => {
    fetchempData();

    fetchLeaveData();
  }, []);

  function fetchLeaveData() {
    const url = `${baseUrl}create-leave/`;
    axios.get(url)
      .then(response => {
        const transformedData = response.data.map(item => ({
          ...item,
          emp: item.emp?.employee || '',
          emp__department: item.emp?.department?.department || '',
          emp__designation: item.emp?.designation?.designation || '',
          type: item.type || '',
          lop: item.lop || ''
        }));
        setviewLeave(transformedData);
      })
      .catch(error => {
        console.log(error);
      });
  }

  function fetchempData() {
    const url = `${baseUrl}add-employee/`;
    axios.get(url)
      .then(response => {
        setEmpData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }


  const handleUser = (event) => {
    setEmp(event.target.value);
  };

  const handleType = (event) => {
    setType(event.target.value);
  };
  const handleReason = (event) => {
    setReason(event.target.value);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append('from_date', startDate.toISOString().slice(0, 10));
    formData.append('to_date', endDate.toISOString().slice(0, 10));
    formData.append('emp', emp);
    formData.append('type', type);
    formData.append('lop', lop);
    formData.append('reason', reason);
    formData.append('addedby', userName);
    formData.append('ip_add', ipAddress);
    formData.append('location', userLocation);

    axios.post(baseUrl + 'create-leave/', formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          console.log('Form submitted successfully!', response.data);
          Swal.fire({
            title: 'Leave Create successfully',
            icon: 'success',
            timer: 5000,
            showConfirmButton: false
          });
          setTimeout(() => {
            window.location.href = '/emp-leave';
          }, 3000);
        }
      })
      .catch(error => {
        console.log(error);
        Swal.fire(
          'Error!',
          'Failed to Create. Please try again later.',
          'error'
        );
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure you want to delete this?',
      icon: 'info',
      confirmButtonText: 'Continue',
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axios.delete(baseUrl + 'delete-leave/' + id + '/')
            .then(function (response) {
              Swal.fire('success', 'Data has been deleted');
              window.location.reload();
            });
        } catch (error) {
          Swal.fire('error', 'Data has not been deleted');
        }
      } else {
        Swal.fire('error', 'Data has not been deleted');
      }
    });
  };

  const columns = [
    { field: 'from_date', headerName: 'From Date', width: 140 },
    { field: 'to_date', headerName: 'To Date', width: 140 },
    { field: 'emp', headerName: 'Employee Name', width: 150 },
    { field: 'emp__department', headerName: 'Employee Dept', width: 150 },
    { field: 'emp__designation', headerName: 'Employee Desg', width: 200 },
    { field: 'type', headerName: 'Leave Type', width: 150 },
    { field: 'lop', headerName: 'Lop Days', width: 150 },
    {
      field: 'delete', headerName: 'Action',
      renderCell: (params) => (
        <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i>
        </button>
      ),
      width: 100
    },
  ];

  return (
    <section className="container mt-4">
      <div className="table-responsive">
        <div className='card'>
          <h3 className="card-header text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
            <i className="fa-solid fa-calendar-days" aria-hidden="true" style={{ color: 'red' }}></i> Employee Leave
          </h3>
          <div className='card-body'>
            <form>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                  <div className="col-sm-9 col-lg-10 controls">
                    <DatePicker
                      name="form_date"
                      selected={startDate}
                      onChange={handleStartDateChange}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      placeholderText={'Please select From date'}
                      dateFormat="dd/MM/yyyy"
                      showMonthDropdown
                      showYearDropdown
                    />
                  </div>
                  <div className="col-sm-9 col-lg-10 controls">
                    <DatePicker
                      selected={endDate}
                      onChange={handleEndDateChange}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      name="to_date"
                      placeholderText={'Please select To date'}
                      dateFormat="dd/MM/yyyy"
                      showMonthDropdown
                      showYearDropdown
                    />
                  </div>
                </div>
              </div>
               <div className="col-sm-9 col-lg-10 controls mt-2">
        <label className="block mb-1 font-medium">Total Days</label>
        <input
          type="text"
          name = {lop}
          value={lop || ""}
          readOnly
          className="form-control bg-light"
          placeholder="Total days will appear here"
        />
      </div>
              <div className="col-md-6 mb-4 mt-4">
                <label htmlFor="user" className="form-label">Select Employee</label>
                <select name="employee_id" id="employee_id" value={emp} className="form-control" onChange={handleUser}>
                  <option value="">Select Employee</option>
                  {empData.map((User, index) => (
                    <option key={index} value={User.id}>{User.employee}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 mb-4 mt-4">
                <label htmlFor="user" className="form-label">Select Leave Type</label>
                <select name="shift_name" id="shift_name" value={type} className="form-control" onChange={handleType}>
                  <option value="">Select Leave Type</option>
                   <option value="Casual Leave">Casual Leave</option>
                   <option value="Sick Leave">Sick Leave</option>
                   <option value="Earned Leave">Earned Leave</option>
                   <option value="Maternity Leave">Maternity Leave</option>
                   <option value="Paternity Leave">Paternity Leave</option>
                </select>
              </div>
               <div className="col-md-6 mb-4 mt-4">
            <label htmlFor="user" className="form-label">Reason</label>
            <textarea
              name="reason"
              value={reason}
              onChange={handleReason}
              rows="3"
              className="w-full border p-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
              placeholder="Enter reason for leave"
            />
          </div>
              <div className="row">
                <div className="col-md-12 text-center mb-5">
                  <button type="button" onClick={submitHandler} className="btn btn-success">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {viewLeave.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={viewLeave}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
    </section>
  );
}

export default LeaveApplication;
